import { startClickListener } from './clickListener';
import { setupRouterTrack } from './routerHook';
import tracker from './Tracker';

/**
 * v-track 指令：绑定动态埋点参数
 */
export const trackDirective = {
  bind(el, binding) {
    const handler = () => {
      const value = binding.value;
      if (!value) {
        return;
      }

      if (typeof value === 'string') {
        tracker.trackClick(value);
        return;
      }

      tracker.trackClick(value.name, value.extra || {});
    };

    el.addEventListener('click', handler);
    el.__trackHandler = handler;
  },
  unbind(el) {
    if (el.__trackHandler) {
      el.removeEventListener('click', el.__trackHandler);
      delete el.__trackHandler;
    }
  },
};

/**
 * 初始化 Tracker（已登录时调用）
 */
export function initTracker(options = {}) {
  if (!sessionStorage.getItem('authorization')) {
    return;
  }

  tracker.init(options);
  startClickListener();
}

/**
 * 注册 Vue 插件
 */
const TrackerPlugin = {
  install(vue) {
    vue.prototype.$track = function track(name, extra) {
      tracker.track({
        event_type: 'custom',
        event_name: name,
        extra: extra || {},
      });
    };

    vue.directive('track', trackDirective);
  },
};

export { tracker, setupRouterTrack, startClickListener };
export default TrackerPlugin;
